
import { defineComponent, PropType } from 'vue'
import { Campaigns } from '@/lib/campaigns'

import { Campaign, Variant } from '@/types'
import { Selection } from '@/types/order'
import { formatPrice, ItemColorFormatter, useItemColorFormatter } from '@/lib/formatters'

export default defineComponent({
  props: {
    campaign: {
      type: Object as PropType<Campaign>,
      required: true
    },
    selections: {
      type: Array as PropType<Selection[]>,
      default: []
    }
  },
  emits: ['change'],
  setup (props, context) {
    const findVariant = (variantId: number) => {
      return props.campaign.variants.find(v => v.id === variantId)
    }

    const emitChange = ({ target }: { target: HTMLInputElement }, index: number, key: string) => {
      const updated = props.selections.map((v, i) => {
        return (i === index) ? { ...v, [key]: +target.value } : v
      })

      context.emit('change', updated)
    }

    const appendSelection = () => {
      const unselectedVariants = props.campaign.variants.filter(v => !props.selections.find(s => s.variantId === v.id))
      const unselectedVariant = unselectedVariants.length > 0 ? unselectedVariants[0] : props.campaign.variants[0]
      const primarySize = Campaigns.primarySize(props.campaign)
      const updated = [...props.selections, { variantId: unselectedVariant.id, itemSizeId: primarySize.id, quantity: 1 }]

      context.emit('change', updated)
    }

    const removeSelection = (index: number) => {
      const updated = props.selections.filter((v, i) => i !== index)

      context.emit('change', updated)
    }

    const thumbnailUrl = (selection: Selection) => {
      const variant = props.campaign.variants.find(v => v.id === selection.variantId)
      return variant?.prints[0]?.thumbnailUrls?.find(u => u.size === 'small')?.url
    }

    return { findVariant, emitChange, appendSelection, removeSelection, thumbnailUrl, formatPrice }
  },
  computed: {
    itemColorFormatter (): ItemColorFormatter {
      return useItemColorFormatter()
    }
  },
  methods: {
    formatItemColor (variant: Variant) {
      return this.itemColorFormatter(variant)
    }
  }
})
